<div [class.show-side-panel]="isShowing">
    <div class="side-panel" id="side-panel" data-qa-id="SidePanel">
        <div #header class="header">
            <div class="side-panel-title-section">
                <mat-icon *ngIf="config.backIconEnabled" data-qa-id="CancelIcon" (click)="cancel()" class="close-button back">arrow_back</mat-icon>
                <h1 data-qa-id="SidePanelTitle" class="side-panel-title"> {{config.title}} </h1>
                <mat-icon data-qa-id="CancelIcon" (click)="cancel()" class="close-button">close</mat-icon>
            </div>
            <div class="divider"></div>
            <div *ngIf="config.alertMessage?.length">
                <nova-banner data-qa-id="NovaBannerAlertMessage" [bannerType]="config.alertType" [bannerMessage]="config.alertMessage" 
                [messageOverrideClass]="config.alertMessageOverrideClass" [extendHeight]="config.extendHeight">
                </nova-banner>
            </div>
        </div>
        <div class="item-content" #contentWrapper id="content-wrapper">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="overlay" (click)="onOverlayClick()"></div>
</div>
